<template>
  <div class="c-side">
    <div @click="showEditModal($event)" class="material-left-nav">
        <a-icon type="plus" />
        <span style="margin-left:10px">添加相册</span>
    </div>
    <div class="list">
      <perfect-scrollbar class="m-scrollbar">
      <div class="item material-btns" :class="{ 'active': cateId === item.album_id }" 
        v-for="(item, index) of folders" :key="index" @click="clickCategory(item)">
        <div class="name">{{ item.album_name }}</div>
        <a-dropdown placement="bottomRight" class='material-btns-icon'>
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                <a-icon type="more" />
            </a>
            <a-menu slot="overlay">
            <a-menu-item @click="showEditModal($event, item)">
              编辑
            </a-menu-item>
            <a-menu-item @click="deleteCategory($event, item)">
              删除
            </a-menu-item>
            </a-menu>
        </a-dropdown>
        <span class="material-btns-count">( {{item.album_count || 0}} )</span>
        <div class="btns material-btns">
        </div>
      </div>
      </perfect-scrollbar>
    </div>
    <editModal v-if="visible" :item="modalData"/>
  </div>
</template>
<style lang="scss" scoped>
.m-scrollbar {
  height: calc(100vh - 280px);
}
.material-left-nav{
  height: 40px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid #eee;
}
.material-btns{
  display: flex;
  align-items: center;
  &-icon{
      position: absolute;
      right: 10px;
      cursor: pointer;
  }
  &-count{
      position: absolute;
      right: 25px;
      font-size: 12px;
      color: #999;
  }
}
</style>
<script>
import editModal from './editModal'
import authority from '@/common/mixins/authority'

export default {
  name: 'Category',
  inject: [ 'parent' ],
  provide() {
    return {
      parent: this
    }
  },
  components: {
    editModal
  },

  data() {
    return {
      loading: false,
      cateId: '',
      folders: [],
      visible: false,
      modalData: null,
      authType:['market','xuetang'],
    }
  },
  mixins: [ authority ],
  async created() {
    await this.getList()
    if(this.folders.length > 0){
      this.parent.changeCategory(this.folders[0])
    }
  },
  methods: {
    async getList() {
      if(!this.canIndex){
          return false
      }
      let res = await this.$store.dispatch('classesAlbumAction', this.searchParams)
      this.folders = res.items
      if(res.items.length == 0){
        return false
      }
      if(!this.cateId){
        this.cateId = res.items[0].album_id
      }
    },

    clickCategory(item) {
      this.cateId = item.album_id
      this.parent.changeCategory(item)
    },
    showEditModal(e, item) {
      this.modalData = item
      this.visible = true
    },
    hideModal(val) {
      if(val){
        this.getList()
      }
      this.visible = false
    },
    submitModal() {
      this.visible = false
      this.getList()
    },
    deleteCategory(e, item) {
      e.stopPropagation()
      let that = this
      this.$confirm({
        title: `确定要删除该相册?`,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          return new Promise(async (resolve, reject) => {
            let res = await that.$store.dispatch('classesAlbumDeleteAction', {album_id: item.album_id })
            if (res) {
              that.$message.success('操作成功~')
              that.getList()
              resolve(res)
            }
          }).catch(error => console.log(error))
        }
      })
    }
  }
}
</script>
